export default __webpack_public_path__ + "static/media/disfigure.7c3c24b7.png";